export default String.raw`
{% assign lookbooks = config.Lookbook.List %}
{% assign lookbooksCount = lookbooks | Size -%}
{% assign current = config.Lookbook.Current %}

<section class="lookbook lookbook-js">
    {% if current %}
        <h2 class="lookbook__title">{{ current.Text }}</h2>
        <div class="lookbook__container with-points">
            {% for item in current.Images %}
                <div class="lookbook__item with-points" data-lookbook-products="{{item.JSON | H}}" data-clicked="false">
                    <img src="css/img/alo.gif" data-src="{{item.Url}}" alt="{{item.Alt}}">
                    <form class="button__group">
                        {% if customer.HidePrices == false %}
                            <button class="secondary-action-button add-all-to-cart-js">
                                <svg class="button__icon">
                                    <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{settings.iconStyle}}'></use>
                                </svg>
                            </button>
                        {% elsif usr.Authenticated == true %}
                            <button class="secondary-action-button add-all-to-cart-js">
                                <svg class="button__icon">
                                    <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{settings.iconStyle}}'></use>
                                </svg>
                            </button>
                        {% endif %}
                        {% if usr.Authenticated == true %}
                            <button class="secondary-action-button add-all-to-wishlist-js show-add-to-wishlist-popup-js">
                                <svg class="button__icon">
                                    <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#clipboard-list-{{settings.iconStyle}}'></use>
                                </svg>
                            </button>
                        {% endif %}
                    </form>
                </div>
            {% endfor %}
        </div>
    {% else %}
        {% if lookbooksCount > 0 -%}
            <h2 class="lookbook__title">{{ translations.Lookbook }}</h2>
            <div class="lookbook__container">
                {% for lookbook in lookbooks %}
                    <a href="{{ page.BaseHref }}{{ lookbook.Url }}">
                        <div class="lookbook__item">
                            {% if lookbook.Images[0].Url -%}
                                <img src="{{ lookbook.Images[0].Url }}" alt="{{ lookbook.Images[0].Alt }}" loading="{% if forloop.index0 == 0 -%}eager{% else -%}lazy{% endif -%}">
                            {% else -%}
                                <img src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}">
                            {% endif -%}
                            <h2>{{ lookbook.Text }}</h2>
                        </div>
                    </a>
                {% endfor %}
            </div>
        {% else -%}
            <h2 class="lookbook__title">{{ translations.Lookbook }}</h2>
            {% include 'partials/common/empty-page.html', title: translations.EmptyLookbook -%}
        {% endif -%}
    {% endif %}
</section>
`